import dayjs from 'dayjs';

import { Text } from '@highlight-cp/core-ui';

export const DateCell = ({ dateString }: { dateString: string | undefined }) => {
  if (!dateString) return <></>;

  return (
    <Text component="span" title={dateString}>
      {dayjs(dateString).format(`MMM DD YYYY`)}
    </Text>
  );
};
